import React from "react";
import { Modal, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const InsuranceInfoModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={500}
      footer={null}
      closable={false}
      centered
      bodyStyle={{
        borderRadius: "12px",
      }}
      style={{
        borderRadius: "12px",
      }}
    >
      <div
        style={{
          position: "relative",
          borderRadius: "12px",
        }}
      >
        {/* Close Button */}
        <Button
          type="text"
          icon={<CloseOutlined style={{ color: "white", fontSize: "16px" }} />}
          onClick={onClose}
          style={{
            position: "absolute",
            top: "-8px",
            right: "-8px",
            zIndex: 10,
            backgroundColor: "#1a1a1a",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            padding: 0,
          }}
        />

        {/* Content */}
        <div style={{ lineHeight: 1.6 }}>
          {/* What is Takaful coverage? */}
          <h3
            style={{
              color: "#e74c3c",
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "5px",
              marginTop: 0,
            }}
          >
            What is Takaful coverage?
          </h3>

          <p
            style={{
              fontSize: "14px",
              color: "#333",
              marginBottom: "2px",
              lineHeight: "1.2",
            }}
          >
            Takaful is commonly referred to as Islamic insurance. This plan
            AlfaMall Muhaffiz Takaful bu JGI – WTO provides coverage to protect
            you against any unforeseen and sudden physical loss, damage and
            theft of the covered item.
          </p>

          <p
            style={{
              fontSize: "14px",
              color: "#333",
              marginBottom: "2px",
            }}
          >
            <strong>Coverage Term:</strong> Annual
          </p>

          <p
            style={{
              fontSize: "14px",
              color: "#333",
              marginBottom: "5px",
            }}
          >
            <strong>Contribution:</strong> 8.5% of product price upto maximum
            product price of PKR 400,000
          </p>

          {/* Events covered */}
          <h3
            style={{
              color: "#e74c3c",
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "5px",
            }}
          >
            Events covered
          </h3>

          <div style={{ marginBottom: "10px" }}>
            <p style={{ fontSize: "14px", color: "#333", marginBottom: "2px" }}>
              a) Accidental and/or Physical damage to screen
            </p>
            <p style={{ fontSize: "14px", color: "#333", marginBottom: "2px" }}>
              b) Theft/snatching
            </p>
            <p style={{ fontSize: "14px", color: "#333", marginBottom: "2px" }}>
              c) Overall repair/damage
            </p>
          </div>

          {/* Benefit Structure */}
          <h3
            style={{
              color: "#e74c3c",
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "5px",
            }}
          >
            Benefit Structure
          </h3>

          <div style={{ marginBottom: "5px" }}>
            <p style={{ fontSize: "14px", color: "#333", marginBottom: "2px" }}>
              a) Upto 10% of the sum covered in case of screen damage
            </p>
            <p style={{ fontSize: "14px", color: "#333", marginBottom: "2px" }}>
              b) Upto 50% of the sum covered in case of Theft/Snatching
            </p>
            <p style={{ fontSize: "14px", color: "#333", marginBottom: "2px" }}>
              c) Upto 100% of the sum covered in case of all damages for all
              covered items
            </p>
          </div>

          {/* Free Look period */}
          <div>
            <span
              style={{
                color: "#e74c3c",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Free Look period:
            </span>
            <span
              style={{
                fontSize: "14px",
                color: "#333",
                marginLeft: "8px",
              }}
            >
              7 days from the date of delivery
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InsuranceInfoModal;
